import { createContext } from 'react'

const METRICS_POSITION_STORAGE_KEY = 'restMetricsPositions'

const ListContext = createContext(null)
const itemKey = Symbol('item')

function getItemData({ item, index, instanceId }) {
  return {
    [itemKey]: true,
    item,
    index,
    instanceId,
  }
}

function isItemData(data) {
  return data[itemKey] === true
}

export { getItemData, isItemData, ListContext, METRICS_POSITION_STORAGE_KEY }
